import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getFasilitasDestinasi } from '../../actions/FasilitasDestinasiAction';
import { DELETE_FASILITASWISATA, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import { logOutUser } from 'actions/AuthAction';
import jwt_decode from 'jwt-decode';

export default function ListFasilitasDestinasi() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    getListFasilitasDestinasiError,
    getListFasilitasDestinasiLoading,
    getListFasilitasDestinasiResult,
  } = useSelector((state) => state.FasilitasDestinasiReducer);

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getFasilitasDestinasi());
    refreshToken();
  }, []);

  // componentDidUpdate(prevProps) {
  //   const { deleteJerseyResult } = this.props;

  //   if (
  //     deleteJerseyResult &&
  //     prevProps.deleteJerseyResult !== deleteJerseyResult
  //   ) {
  //     swal('Sukses!', deleteJerseyResult, 'success');
  //     this.props.dispatch(getListJersey());
  //   }
  // }

  const removeData = async (id) => {
    await axios.delete(DELETE_FASILITASWISATA + `${id}`);
    swal('Sukses!', 'Fasilitas Destinasi berhasil dihapus', 'success');
    history.push('/admin');
    history.push('/admin/fasilitasDestinasi');
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Fasilitas Destinasi</CardTitle>
              <Link
                to={'/admin/fasilitasDestinasi/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Destinasi
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Nama</th>
                    <th>Destinasi</th>
                    <th>Phone</th>
                    <th>Fasilitas</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getListFasilitasDestinasiResult ? (
                    Object.keys(getListFasilitasDestinasiResult).map((key) => (
                      <tr key={key}>
                        <td>{getListFasilitasDestinasiResult[key].id}</td>
                        <td>
                          <img
                            src={
                              getListFasilitasDestinasiResult[key].gambar.split(
                                ','
                              )[0]
                            }
                            width='100'
                            alt={getListFasilitasDestinasiResult[key].destinasi}
                          />
                        </td>
                        <td>{getListFasilitasDestinasiResult[key].nama}</td>
                        <td>
                          {getListFasilitasDestinasiResult[key].destinasi}
                        </td>
                        <td>{getListFasilitasDestinasiResult[key].phone}</td>

                        <td>
                          {getListFasilitasDestinasiResult[key].fasilitas}{' '}
                        </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/fasilitasDestinasi/edit/' +
                              getListFasilitasDestinasiResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(
                                getListFasilitasDestinasiResult[key].id
                              )
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getListFasilitasDestinasiLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getListFasilitasDestinasiError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getListFasilitasDestinasiError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
